module.exports = __webpack_public_path__ + "img/15.99c77027.png";